/**
 * To products pages
 */

import React from 'react';
import { Outlet } from 'react-router-dom';
import ProductProvider from 'components/app/e-commerce/ProductProvider';

const ProductElement = () => {
  return (
    <ProductProvider>
      <Outlet />
    </ProductProvider>
  );
};

export default ProductElement;
